import React from "react";

import styles from "./Quote.module.scss";
import Quotes from "../Pictos/Quotes";

export default function Quote({sourceName, sourceJob, sourceText, children}) {
    return (
        <blockquote className={styles.Main}>
            <Quotes/>
            <p className={'italic'}>
                { children }
            </p>

            <div className={styles.Source}>
                {
                    sourceName || sourceJob ?
                        <p>
                            { sourceName ? <strong>{sourceName}</strong> : null }
                            { sourceJob ?? null }
                        </p>
                        : null
                }
                <p dangerouslySetInnerHTML={{__html:sourceText}}/>
            </div>
        </blockquote>
    )
}
